import styled from '../../../theme'

const Label = styled.div<{ size?: number }>`
  color: black;
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;
`

export default Label
